import * as Immutable from 'immutable';
import {
  RESET_ADHOC2FA,
  SET_ADHOC2FA_PREP_REQUESTED,
  SET_ADHOC2FA_PREP_COMPLETED,
  SET_ADHOC2FA_PREP_FAILED,
  SET_ADHOC2FA_SEND_REQUESTED,
  SET_ADHOC2FA_SEND_COMPLETED,
  SET_ADHOC2FA_SEND_FAILED,
  SET_ADHOC2FA_CONFIRM_REQUESTED,
  SET_ADHOC2FA_CONFIRM_COMPLETED,
  SET_ADHOC2FA_CONFIRM_FAILED,
  SET_ADHOC2FA_STATUS_ABORTED,
  SET_ADHOC2FA_STATUS_REQUESTED,
  SET_ADHOC2FA_STATUS_COMPLETED,
  SET_ADHOC2FA_STATUS_FAILED,
} from '../../actions/adhoc2fa/types';
import { Action } from '../../utils/redux';

export interface State {
  statusRequesting: boolean;
  status: {
    items:
      | [
          {
            ContactID: string;
            status: string;
          },
        ]
      | [];
  };
  error: Error | null;
  prep: string;
  sending: boolean;
  send: {
    id: string;
  } | null;
  confirming: boolean;
  confirm: {
    id: string;
    verifyCode: string;
    verifySuccessful: boolean;
  } | null;
}

type ReducerActions =
  | Action<typeof RESET_ADHOC2FA>
  | Action<typeof SET_ADHOC2FA_PREP_REQUESTED>
  | Action<typeof SET_ADHOC2FA_PREP_COMPLETED, string>
  | Action<typeof SET_ADHOC2FA_PREP_FAILED, Error>
  | Action<typeof SET_ADHOC2FA_SEND_REQUESTED>
  | Action<
      typeof SET_ADHOC2FA_SEND_COMPLETED,
      {
        id: string;
      }
    >
  | Action<typeof SET_ADHOC2FA_SEND_FAILED, Error>
  | Action<typeof SET_ADHOC2FA_CONFIRM_REQUESTED>
  | Action<
      typeof SET_ADHOC2FA_CONFIRM_COMPLETED,
      {
        id: string;
        verifyCode: string;
        verifySuccessful: boolean;
      }
    >
  | Action<typeof SET_ADHOC2FA_CONFIRM_FAILED, Error>
  | Action<typeof SET_ADHOC2FA_STATUS_ABORTED>
  | Action<typeof SET_ADHOC2FA_STATUS_REQUESTED>
  | Action<
      typeof SET_ADHOC2FA_STATUS_COMPLETED,
      {
        items:
          | [
              {
                ContactID: string;
                status: string;
              },
            ]
          | [];
      }
    >
  | Action<typeof SET_ADHOC2FA_STATUS_FAILED, Error>;

const schema: State = {
  error: null,
  prep: '',
  sending: false,
  send: null,
  confirming: false,
  confirm: null,
  statusRequesting: false,
  status: {
    items: [],
  },
};

export const initialState = Immutable.Map(schema);

const reducer = (state = initialState, action: ReducerActions) => {
  switch (action.type) {
    case RESET_ADHOC2FA:
      return initialState;

    case SET_ADHOC2FA_PREP_REQUESTED:
      return state.set('error', null).set('prep', '');

    case SET_ADHOC2FA_PREP_COMPLETED:
      return state.set('error', null).set('prep', action.payload);

    case SET_ADHOC2FA_PREP_FAILED:
      return state.set('error', action.payload);

    case SET_ADHOC2FA_SEND_REQUESTED:
      return state.set('error', null).set('send', null).set('sending', true);

    case SET_ADHOC2FA_SEND_COMPLETED:
      return state
        .set('error', null)
        .set('sending', false)
        .set('send', action.payload);

    case SET_ADHOC2FA_SEND_FAILED:
      return state
        .set('error', action.payload)
        .set('send', null)
        .set('sending', false);

    case SET_ADHOC2FA_CONFIRM_REQUESTED:
      return state
        .set('error', null)
        .set('confirm', null)
        .set('confirming', true);

    case SET_ADHOC2FA_CONFIRM_COMPLETED:
      return state
        .set('error', null)
        .set('confirming', false)
        .set('confirm', action.payload);

    case SET_ADHOC2FA_CONFIRM_FAILED:
      return state
        .set('error', action.payload)
        .set('confirm', null)
        .set('confirming', false);

    case SET_ADHOC2FA_STATUS_REQUESTED:
      return state.set('error', null).set('statusRequesting', true);

    case SET_ADHOC2FA_STATUS_ABORTED:
      return state.set('error', null).set('statusRequesting', false);

    case SET_ADHOC2FA_STATUS_COMPLETED:
      return state
        .set('error', null)
        .set('statusRequesting', false)
        .set('status', action.payload);

    case SET_ADHOC2FA_STATUS_FAILED:
      return state.set('statusRequesting', false).set('error', action.payload);

    default:
      return state;
  }
};

export default reducer;
